// extracted by mini-css-extract-plugin
export var overlay_loader = "Layout-module--overlay_loader--MH9Ch";
export var overlay_loader__percent = "Layout-module--overlay_loader__percent--+0rBD";
export var overlay_loader__sign = "Layout-module--overlay_loader__sign--9ZZ6s";
export var root = "Layout-module--root--N1-V3";